/*
 *
 * CheckoutOne constants
 *
 */

export const DEFAULT_ACTION = 'app/CheckoutOne/DEFAULT_ACTION';

export const MERCHANT_CHECKOUT_ONE_REQUEST = 'merchant-checkout-one-request';

export const DEV_STUDIO_CANVAS_URL =
  'https://www.cashfree.com/devstudio/canvas';

export const CANVAS_DOCS_URL = 'https://www.cashfree.com/docs/payments/checkout/customize#how-to-customise-the-checkout-page';

export const VISUAL_CUSTOMISATION_PATH = 'visual-customisation';

export const BUSINESS_CUSTOMISATION_PATH = 'business-customisation';

export const VISUAL_CUSTOMISATION = 'Visual Customisation';

export const BUSINESS_CUSTOMISATION = 'PG Business Customisation';

export const NAVIGATION_OPTIONS = [
  {
    name: VISUAL_CUSTOMISATION,
    path: VISUAL_CUSTOMISATION_PATH,
  },
  {
    name: BUSINESS_CUSTOMISATION,
    path: BUSINESS_CUSTOMISATION_PATH,
  },
];
